"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _flash = require("../flash");

var _graphql = require("../graphql");

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const GraphQLProviderWithAuth = ({
  useAuth,
  graphQLClientConfig = {
    headers: {}
  },
  children,
  ...rest
}) => {
  const {
    loading,
    isAuthenticated,
    getToken,
    type
  } = useAuth();
  const [authToken, setAuthToken] = (0, _react.useState)();
  (0, _react.useEffect)(() => {
    const fetchAuthToken = async () => {
      const token = await getToken();
      setAuthToken(token);
    };

    if (isAuthenticated) {
      fetchAuthToken();
    }
  }, [isAuthenticated, getToken]); // This really sucks because rendering is completely blocked whilst we're
  // restoring authentication. In a lot of cases that's OK since the token is stored
  // in localstorage or a secure cookie.

  if (loading) {
    return null;
  }

  if (!isAuthenticated) {
    return /*#__PURE__*/_react.default.createElement(_graphql.GraphQLProvider, (0, _extends2.default)({
      config: graphQLClientConfig
    }, rest), children);
  } // The user is authenticated, so we have to wait for the auth token to be retrieved
  // before continueing.


  if (!authToken) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement(_graphql.GraphQLProvider, {
    config: { ...graphQLClientConfig,
      headers: {
        /** `auth-provider` is used by the API to determine how to decode the token */
        'auth-provider': type,
        authorization: "Bearer ".concat(authToken),
        ...graphQLClientConfig.headers
      }
    }
  }, children);
};
/**
 * Redwood's Provider is a zeroconf way to tie together authentication and
 * GraphQL requests.
 *
 * When `AuthProvider` is instantiated this component will automatically add
 * Authorization headers to each request.
 */


const RedwoodProvider = ({
  useAuth = window.__REDWOOD__USE_AUTH,
  graphQLClientConfig,
  children,
  ...rest
}) => {
  if (typeof useAuth === 'undefined') {
    return /*#__PURE__*/_react.default.createElement(_graphql.GraphQLProvider, (0, _extends2.default)({
      config: graphQLClientConfig
    }, rest), /*#__PURE__*/_react.default.createElement(_flash.FlashProvider, null, children));
  }

  return /*#__PURE__*/_react.default.createElement(GraphQLProviderWithAuth, (0, _extends2.default)({
    useAuth: useAuth,
    graphQLClientConfig: graphQLClientConfig
  }, rest), /*#__PURE__*/_react.default.createElement(_flash.FlashProvider, null, children));
};

var _default = RedwoodProvider;
exports.default = _default;